import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { purchaseReturnViewAction } from "../../../redux/actions/purchase-action";
import CreateEditViewPurReturn from "../../../components/purchase-section/purchase-return/create-edit-view-pur-return";

const EditPurchaseReturn = () => {
  const { id } = useParams();

  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true);
    dispatch(purchaseReturnViewAction(id, onSuccPur, onErrPur));
  }, []);

  const onSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };

  const [searchParams] = useSearchParams();
  const isNew = searchParams.has("new");

  return (
    <InnerLayout backBtn={true} title="Purchase Return Edit">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <CreateEditViewPurReturn
          // <CreateEditViewPurchaseReturn
          clickedplus={isNew}
          payto={orderDetail?.orderData?.prt_pay_to_address}
          shipto={orderDetail?.orderData?.prt_ship_to_address}
          pageType="purchase return"
          page="edit"
          disabled={
            true && orderDetail?.orderData?.prt_order_status !== "draft"
          }
          orderDetail={orderDetail?.itemData}
          vendorDetails={[orderDetail?.orderData]}
        />
      )}
    </InnerLayout>
  );
};

export default EditPurchaseReturn;
